module.exports = __webpack_public_path__ + "static/media/face1.90a61a0b.jpg";